var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nft-grid"},_vm._l((_vm.tokens),function(token){return _c('NfToken',{key:token.tokenId.toString(),attrs:{"token":token,"nft-data":_vm.nftData,"dumbapps":_vm.dumbapps}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }